<template lang="pug">
extends ../dynamic-filter-template.pug

block item
    template(#product.id="props")
        span(:class="props.value.bold ? 'font-weight-bold' : null")
            | {{ props.value.display_name }}

    template(#receipts.drawer_session_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}

    template(#receipts.day_operation_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} </br>
            small.text-muted
                | {{ props.value.staff_name }}

</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import dynamicFilterBase from '@js/components/filter/dynamic-filter-base';
import tillFilterMixin from '@js/components/till-filter/till-filter-mixin';

export default {
    extends: dynamicFilterBase,

    mixins: [tillFilterMixin],

    data() {
        let that = this;

        return {
            preSelectOperator: true,

            returnOperatorValueList: true,

            externalRemotes: {
                products(query) {
                    return that
                        .getProductListIfNecessary({ query })
                        .then(data => {
                            return data.map(d => ({
                                id: d.id,
                                display_name: d.name,
                            }));
                        });
                },
            },
        };
    },

    computed: {
        ...mapState('product', ['searchMeta']),
        ...mapState('tillFilter', ['filters']),

        loading() {
            return this.onLoading('get-product-meta');
        },
    },

    created() {
        this.getSearchMetaIfNecessary();
        this.getProductListIfNecessary();
    },

    methods: {
        ...mapActions('product', ['getSearchMetaIfNecessary']),

        ...mapActions('product', ['getProductListIfNecessary']),

        ...mapMutations('tillFilter', ['setFilters']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter/product/product-dynamic-filter.vue